<template>
  <div class="content-container">
    <BannerSearch> </BannerSearch>
    <div class="content">
      <div class="content-box">
        <!-- <SideTap :title="this.$route.hash" :keys="tags" :size="16" :padding="15" :margin="15" :family="'MohrRounded'"> </SideTap> -->
        <SideTap class="win" :title="this.$route.hash"  :size="22"
          :keys="tags" :pad="12" :padding="35" :width="'100%'">
        </SideTap>
        <!-- <SideTap class="pad" :title="this.$route.hash" :size="22"
          :keys="tags" :padding="35" :width="'100%'"></SideTap> -->

        <div class="title-container">
          <div class="title-innerbox">
            <div class="title-title">{{ article.name }}</div>
            <ul class="title-ul" id="test">
              <li class="title-li" @click="goDetail(item)" v-for="item, index in  article.articles" :key="index">
                {{ item.title }}
              </li>

            </ul>
          </div>
        </div>
      </div>

    </div>
    <Featured></Featured>
  </div>
</template>

<script>
import Featured from "../components/Featured.vue";
import SideTap from "../components/SideTap.vue";
import BannerSearch from "../components/BannerSearch.vue";

export default {
  components: { Featured, SideTap, BannerSearch },
  data() {
    return {
      list: '',
      tags: [
      ],
      article: [

      ],
    };
  },
  mounted() {
    var count = 0
    let timer = setInterval(() => {
      count++
      if (count >= 50) {
        clearInterval(timer)
      }
      if (this.$store.state.class != '') {
        this.$store.state.class.map(item => {
          item.subClassifications.map(it => {
            if (it.id == this.$route.params.name) {
              this.article = it
              item.subClassifications.map(res => {
                this.tags.push(res.name)
              })
              this.list = item.subClassifications
            }
          })
        })

        clearInterval(timer)
      }
    }, 100);
    console.log(this.list);
  },
  methods: {
    goDetail(item) {
      console.log(item);
      this.$router.push({
        path: '/article',
        query: { id: item.id }
      })
    },
    clickArt(value) {
      console.log(value);
      this.list.map(item => {
        if (item.name == value) {
          this.article = item
        }
      })
    },
    showList() {
      if (document.getElementById("test").style.marginBottom == "621px") {
        document.getElementById("test").style.marginBottom = "30px";
      } else {
        document.getElementById("test").style.marginBottom = "621px";
      }
    },
  },
  created() { },
};
</script>

<style lang="scss" scoped>


@import "../assets/scss/recontent.scss";
@import "../assets/scss/content.scss";
</style>